import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { CheckCircle2, Users, Trophy, Briefcase, Award } from 'lucide-react';
import about_img from '../assets/about.jpg';
import partners_1 from '../assets/videos/Clients-logo.png';
import partners_2 from '../assets/videos/companies.png';
import './About.css';

const About = ({ setPlayState }) => {
  
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 50 });
  }, []);

  const stats = [
    { label: "Students Trained", value: "500+", icon: <Users size={24} /> },
    { label: "Placement Rate", value: "95%", icon: <Trophy size={24} /> },
    { label: "Hiring Partners", value: "50+", icon: <Briefcase size={24} /> }
    
  ];

  return (
    <section className='about-section'>
      <h2 className="contact-title">About Us</h2>
      
      {/* Background Decor */}
      <div className="bg-blur blur-1"></div>

      <div className='about-container'>
        
        {/* --- LEFT: IMAGE SECTION --- */}
        <div className="about-left" data-aos="fade-right">
          <div className="image-wrapper">
            <img src={about_img} alt="About Mandi Hariyanna Academy" className='about-img' />
            
            {/* Floating Badge */}
            {/* <div className="experience-badge">
              <h3>10+</h3>
              <p>Years of<br/>Excellence</p>
            </div> */}
          </div>
        </div>

        {/* --- RIGHT: CONTENT SECTION --- */}
        <div className="about-right" data-aos="fade-left">
          <h4 className="section-subtitle">Who We Are</h4>
          <h2 className="section-title">Nurturing <span className="highlight">Tomorrow's Leaders</span></h2>
          
          <p className="description">
            At <strong>Mandi Hariyanna Academy</strong>, we bridge the gap between academic theory and industry reality. 
            Our courses are designed to offer industry-relevant skills with a focus on practical learning, 
            ensuring you are job-ready from day one.
          </p>
          
          <div className="features-list">
            <div className="feature-item">
              <CheckCircle2 className="feature-icon" />
              <span>Expert Industry Mentors</span>
            </div>
            <div className="feature-item">
              <CheckCircle2 className="feature-icon" />
              <span>100% Practical Training</span>
            </div>
            <div className="feature-item">
              <CheckCircle2 className="feature-icon" />
              <span>Dedicated Placement Support</span>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="mini-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-box">
                <div className="stat-icon">{stat.icon}</div>
                <div>
                  <h4>{stat.value}</h4>
                  <span className="stat-label">{stat.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* --- STATIC PARTNERS SECTION --- */}
      <div className="partners-section" data-aos="fade-up">
        <div className="partners-header">
          <h3>TOP Hiring Companies</h3>
          <div className="line"></div>
        </div>

        {/* Static Image Display - No Animation */}
        <div className="partners-display">
          <div className="partner-img-box">
             <img src={partners_1} alt="Hiring Partners Group 1" className="static-banner" />
          </div>
          <div className="partner-img-box">
             <img src={partners_2} alt="Hiring Partners Group 2" className="static-banner" />
          </div>
        </div>
      </div>

    </section>
  );
};

export default About;